module.exports = __webpack_public_path__ + "img/iconlock2.2f1852f0.png";